<template>
  <main-layout :title="title" :is-loading="isLoading" :is-show-user-header="true">
    <mypage-reservation-finish
      @set-title="setTitle"
      @startLoading="startLoading"
      @endLoading="endLoading"
    >
    </mypage-reservation-finish>
  </main-layout>
</template>
<script>
import MainLayout from '../components/layout/MainLayout.vue' 
import MypageReservationFinish from '../components/mypage/mypage-reservation/MypageReservationFinish'
export default {
  name: 'MypageReservation',
  components: {
    MainLayout,
    MypageReservationFinish
  },
  data() {
    return {
      isLoading: false,
      title: '予約登録完了 | Svenson'
    }
  },
  methods: {
    setTitle(title) {
      this.title = title
    },
    startLoading() {
      this.isLoading = true
    },
    endLoading() {
      this.isLoading = false
    }
  },
  beforeRouteLeave(to, from, next) {
    if (to.name === 'mypage-reservation') {
      next({ name: 'mypage'}) // Should direct to mypage if clicking the back button.
    } else {
      next()
    }
  }
}
</script>